<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_16">Nazar, a boy of almost 14, has enjoyed a peaceful and idyllic life on a simple farm in the Nineveh Plains of Iraq, where he routinely helped his father with the chores, attended the small village school in Karemlesh, and played soccer with his friends when he had free time. But then, radical militants conquer the city of Mosul and suddenly sweep through the entire region of the Nineveh Plains in a tsunami of terror, and Nazar’s quiet world is abruptly torn apart. He is suddenly forced to make challenging decisions when he observes, with horror, his own people frantically running away from the quiet village he grew up in, trying desperately to escape to safety. Within hours, he will leave his boyhood behind forever and will undertake a journey which will shape him into a young man of extraordinary selflessness and courage.</p>
<p class="block_17" id="calibre_pb_5"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_005.vue?5cf23166